import { NativeAudio } from "@ionic-native/native-audio";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "./../../providers/service/service";
import { ShopperBuyProductPayScanConfirmPage } from "./../shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-buy-product-pay-scan",
  templateUrl: "shopper-buy-product-pay-scan.html",
})
export class ShopperBuyProductPayScanPage {
  data = { merchant_id: "", shop_name: "", avalible: "", price: "" };
  scanSub: any;
  merchant_id = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    public translateService: TranslateService,
    private services: ServiceProvider,
    private nativeAudio: NativeAudio,
    private storage: Storage
  ) {
    this.data = this.navParams.data;
    this.merchant_id = this.navParams.data.merchant_id;
    this.nativeAudio.preloadSimple("uniqueId1", "assets/sounds/qr.aac");
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // console.log('ionViewDidLoad ShopperBuyProductPayScanPage');
    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', text);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            var text = JSON.parse(result);

            if (text.merchant_id == this.merchant_id) {
              this.nativeAudio.play("uniqueId1");
              this.navCtrl.push(ShopperBuyProductPayScanConfirmPage, {
                result: text.discount,
                data: this.data,
              });
            } else {
              this.translateService
                .get("Invalid discount.")
                .subscribe((value) => {
                  this.services.presentToast(value);
                });
            }

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product-pay-scan/shopper-buy-product-pay-scan.ts